import { BackendModel, BackendService } from '../../core/backend.service';
import { Permission } from '../permission/permission.model';

export class Role extends BackendModel {

  static path = '/roles/';

  name: string;
  displayName: string;
  description: string;
  permissions?: Permission[];

  constructor(protected backendService: BackendService, model?: Role) {
    super(backendService, model);
  }

}



// WEBPACK FOOTER //
// ./src/app/security/role/role.model.ts